<template>
	<v-text-field
		v-bind:value="cellValue"
		v-bind:id="ctrlId"
		v-bind:prefix="prefix"
		@change="onValueChanged($event)"
		:readonly="isReadOnly || (id == '20' && rowLabel == 'Total R&D conduct') ? true : false"
		suffix=""
		@input="onValueInput($event)"
		height="24"
		:rules="required"
		:class="highlightStyle"
		:disabled="disabled"
		@focus="checkRules()"
		></v-text-field>
</template>
<script>
import { answerService } from '../../services/answerService';
import cellErrorHighlightMixin from './mixins/cellErrorHighlightMixin.js';

export default {
	name: 'ValueCell',
	mixins: [cellErrorHighlightMixin],
  props: {
		name: String,
    index: Number,
		qId: String,
    value: Number,
		prefix: String,
    id: String,
		/* This field was checked in a conditional render but did nothing to change the rendering.
			keeping it here because I don't know if it's needed. */
    hasOutline: Boolean,
    isReadOnly: Boolean,
    disabled: Boolean,
		subHeader: String,
		rowLabel: String
  },
  data: () => ({
		requiredSizeOnLoad: 0,
		required: [
			// v => !!v || 'Required field!',
			v => (v && v.length <= 15) || !v || 'Value must not exceed 12 digits',
			v => (v && /^[^-]/.test(v)) || (v === -1) || !v || 'No negative numbers allowed',
			v => (v && /\.\d*$/.test(v) === false) || !v || 'No decimals allowed',
			v => (v && /^(\d+|\d{1,3}(,\d{3})*)?$/.test(v)) || v === 'N/A' || (v === -1) || !v || 'Only numbers allowed'
		],
    theValue: null
  }),
  watch: {
		value: function (newVal, oldVal) {
			// For dynamic rows, the values have to be set to 0 for them to save properly as well as
			// display correctly. There is an unwanted behavior when deleting rows if the data for the ValueCell is null. (v-for behavior)
			if (newVal || newVal == 0) {
				if (this.theValue) {
					this.theValue.value = newVal;
				} else {
					this.theValue = answerService.getAnswerValue(newVal);
				}
			}
    },
    disabled: function (newVal, oldVal) {
			if (newVal === true) {
				if (this.theValue) {
          this.theValue.value = Number.MIN_SAFE_INTEGER;
          this.onValueChanged();
        }
      } else {
			  this.theValue.value = 0;
        this.onValueChanged();
      }
	}
  },
  mounted () {
    this.theValue = (this.value != null) ? answerService.getAnswerValue(this.value) : answerService.getAnswerValue(null);
      if (this.theValue.value === Number.MIN_SAFE_INTEGER) {
              this.$emit('update:disable', true);
			}
  this.requiredSizeOnLoad = this.required.length;
 },
  computed: {
		ctrlId: function () {
      return this.name + '_' + this.index + '_' + this.id;
    },
    prefixValue: function () {
      return !this.prefix ? '' : this.prefix;
    },
    cellValue: function () {
      return !this.theValue ? '' : this.theValue.strValue;
		}
  },
  methods: {
		getMaxLength: function () {
      return 19;
    },
    onValueChanged: function () {
      this.$emit('update', {
        answerId: this.name,
        index: this.index,
        value: this.theValue.value,
				subHeader: this.subHeader
      });
		},
    onValueInput: function (evt) {
      const regex = /,/gi;
      const val = evt.replace(regex, '');
      this.theValue.value = parseInt(val);
      this.$emit('update', {
        answerId: this.name,
        index: this.index,
        value: this.theValue.value,
		subHeader: this.subHeader
      });
		},
		checkRules: function () {
			if (this.required.length === this.requiredSizeOnLoad) {
				this.required.push(v => (!!v) || 'Required field!');
			}
		}
  }
};
</script>

<style scoped>
.row-header {
  font-weight: bold;
  color: #13314f;
}
.v-text-field >>> input {
  text-align: right;
  padding: 3px;
}
</style>
